import { useEffect, useState } from "react";
import "styles/pay/payments.css";
import PropTypes from "prop-types";
import { LogPaymentEvent } from "utils/logger";
import { mercadoPago as fetchMercadoPagoPreference } from "services/Payments";
import { ReactComponent as ArrowIcon } from "assets/icons/left-arrow.svg";

const Selectgateway = ({ setFormConfig, user }) => {
  const [errorComponent, setErrorComponent] = useState(null);
  const [loadingComponent, setLoadingComponent] = useState(false);

  useEffect(() => {
    if (document.getElementById("mercadopago-sdk")) return;

    const script = document.createElement("script");
    script.id = "mercadopago-sdk";
    script.src = "https://sdk.mercadopago.com/js/v2";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const scriptElement = document.getElementById("mercadopago-sdk");
      if (scriptElement) {
        document.body.removeChild(scriptElement);
      }
    };
  }, []);

  const redirectToCheckout = (prefId) => {
    if (!window.MercadoPago) {
      setLoadingComponent(false);
      return;
    }

    const mp = new window.MercadoPago(
      process.env.REACT_APP_API_KEY_MERCADOPAGO,
      { locale: "es-CO" },
    );

    mp.checkout({
      preference: { id: prefId },
      autoOpen: true,
    });

    setLoadingComponent(false);
  };

  useEffect(() => {
    const getMercadoPagoId = async () => {
      try {
        setErrorComponent(null);
        setLoadingComponent(true);

        const response = await fetchMercadoPagoPreference({
          codigo: user?.codigo,
          contrato: user?.contrato,
          tipo: user?.tipo,
          valor: user?.monto,
        });

        const prefId = response.data;
        redirectToCheckout(prefId);
      } catch (err) {
        console.error(err);
        setErrorComponent(
          "No se pudo obtener el ID de pago. Intenta nuevamente.",
        );
        setLoadingComponent(false);
      }
    };

    if (user) {
      getMercadoPagoId();
    }
  }, [user]);

  const handleBackNavigation = () => {
    LogPaymentEvent("NAVIGATION", "back_step");
    setFormConfig({ step: 3 });
  };

  return (
    <div className="payment-gateway-container">
      {errorComponent && (
        <div className="error-message" role="alert">
          {errorComponent}
        </div>
      )}

      {loadingComponent && <p>Redirigiendo a Mercado Pago...</p>}

      <button className="btn-back-step" onClick={handleBackNavigation}>
        <ArrowIcon />
        Regresar
      </button>
    </div>
  );
};

Selectgateway.propTypes = {
  setFormConfig: PropTypes.func.isRequired,
  user: PropTypes.shape({
    contrato: PropTypes.string.isRequired,
    titular: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    monto: PropTypes.number.isRequired,
    codigo: PropTypes.string.isRequired,
    tipo: PropTypes.string.isRequired,
    url_payU: PropTypes.string,
  }).isRequired,
  setUser: PropTypes.func.isRequired,
};

export default Selectgateway;
